import React from 'react';
import { EditOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';

interface TriggerIconsProps {
	isOpen: boolean;
	showEditIcon?: boolean;
}

export function TriggerIcons({ isOpen, showEditIcon = true }: TriggerIconsProps): JSX.Element {
	return (
		<>
			{showEditIcon && <EditOutlined className="custom-edit-icon" />}
			<span className="custom-arrow-icon">{isOpen ? <UpOutlined /> : <DownOutlined />}</span>
		</>
	);
}
